
import { defineComponent } from "vue"
import CardRaritiesIndex from "@/components/card_rarities/Index.vue"

export default defineComponent({
  components: {
    CardRaritiesIndex
  }
})
